// The 3 sections of the Family Dashboard. Content for each is wired up later —
// for now every section renders as "coming soon".
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import Diversity3Icon from '@mui/icons-material/Diversity3';

export const familyDashboardSections = [
  {
    id: 'segmentation-framework',
    title: 'Family-Based Household Segmentation Framework',
    description: 'Segments households into family-based groups for targeted analysis.',
    icon: AccountTreeIcon,
    accent: 'var(--cat-household)',
  },
  {
    id: 'priority-index',
    title: 'Family Priority Index',
    description: 'Ranks families by priority using survey-driven indicators.',
    icon: PriorityHighIcon,
    accent: 'var(--cat-subhadra)',
  },
  {
    id: 'personas',
    title: 'Family Personas',
    description: 'Persona profiles built from family and household characteristics.',
    icon: Diversity3Icon,
    accent: 'var(--cat-women-child)',
  },
];

export const getFamilyDashboardSectionById = (id) =>
  familyDashboardSections.find((s) => s.id === id) || null;

export default familyDashboardSections;
